import { InstagramWidget } from '../scripts/InstagramWidget';
import { InstagramStoryblok } from '../types/generated-storyblok';

interface ContentBlockInstagramProps {
  blok: InstagramStoryblok;
}

export const ContentBlockInstagram = ({ blok }: ContentBlockInstagramProps) => (
  <div className="mx-auto w-full max-w-lg">
    <InstagramWidget className="w-full max-w-lg" url={blok.postUrl} />
  </div>
);
